import KatalLogger from '@amzn/katal-logger';
import { environment } from './environment';

export const logger = new KatalLogger({
  url: environment.loggerUrl,
});
